export type { ModuleKey } from './defaults';
export { defaultModules } from './defaults';
export {
  collectEnabledModulePaths,
  getModuleConfigValue,
  isModuleEnabled,
  mergeModulesWithDefaults,
} from './module-resolver';
export { moduleConfigSchema } from './module-schema';
export type { ThirdPartyConnectionAction } from './third-party-connection';
export {
  isE2eTestOrgProvisioningSkipped,
  isThirdPartyProvisioningSkipped,
  resolveThirdPartyConnectionName,
  resolveThirdPartyConnectionState,
  resolveThirdPartyConnectionTransition,
  THIRD_PARTY_CONNECTION_NAME,
} from './third-party-connection';
export type {
  ExtractModuleKeys,
  FeatureFlag,
  Module,
  ModuleConfig,
} from './types';
export { featureFlags, featureFlagSchema } from './types';

import type { FeatureFlag } from './types';
import { featureFlagSchema } from './types';

/**
 * All values that can appear in an org's `features` string in the DB.
 * Equivalent to `FeatureFlag` — the legacy module-backed feature strings
 * (compliance, third_party, approvers, …) were retired (RSP-5881); module
 * enablement is driven solely by the module tree. Any such string still
 * sitting in a DB row is dropped by `parseOrgFeatures`.
 */
export const orgFeatureSchema = featureFlagSchema;
export type OrgFeature = FeatureFlag;

/**
 * Parse a comma-separated features string from the DB into typed OrgFeature[].
 * Unrecognised values (including retired legacy feature strings) are dropped.
 */
export const parseOrgFeatures = (raw: string): OrgFeature[] =>
  raw
    .split(',')
    .map((f) => f.trim())
    .filter(Boolean)
    .filter((f): f is OrgFeature => orgFeatureSchema.safeParse(f).success);
